import { api } from "../../app/api.js";
import { store } from "../../app/store.js";
import { display_errors } from "../../helpers/forms.js";

export default {
    template: `
        <div class="column marg-top">
            <div class="container">
                <h1>My Subscription</h1>
        
                <div id="no-subscription" class="center hidden">
                    <p>You don't currently have a subscription</p>
                    <a href="/subscriptions"><button class="btn btn-primary">View Plans</button></a>
                </div>
                
                <div id="SubscriptionLoadErrors" class="errors hidden"></div>
                <form id="subscription-form" class="form hidden">
                    <div class="input">
                        <label for="Plan">Plan</label>
                        <input type="text" id="Plan" name="plan" disabled/>
                    </div>
        
                    <div class="input">
                        <label for="Cost">Cost</label>
                        <input type="text" id="Cost" name="cost" disabled/>
                    </div>
        
                    <div class="input">
                        <label for="DateExpires">Renewal Date</label>
                        <input type="text" id="DateExpires" name="date_expires" disabled/>
                    </div>
        
                    <p>
                        We are still building this part of the website.
                        If you wish to cancel your subscription, please contact us at <a href="mailto:support@kingearthquake.uk">support@kingearthquake.uk</a>.
                    </p>
                </form>
            </div>
        </div>
     `,

    $form: null,

    async onMount() {
        const auth = store.get('auth');

        if (!auth.logged_in) {
            window.history.pushState({}, "", "/");
            window.dispatchEvent(new PopStateEvent('popstate'));
        }

        this.$form = document.getElementById('subscription-form');

        api.get({
            url: '/account/subscription',
            success: (response) => {
                if (!response.subscription_id) {
                    document.getElementById('no-subscription').classList.remove('hidden');
                    return;
                }

                this.$form.classList.remove('hidden');

                let cost = ''
                if (response.cost) {
                    cost = '£' + (response.cost/100).toFixed(2);
                }

                let renewal_date = '';
                if (response.date_expires) {
                    let date_expires = new Date();
                    renewal_date = date_expires.toLocaleDateString();
                }

                this.$form.plan.value = response.plan_name ?? '';
                this.$form.cost.value = cost;
                this.$form.date_expires.value = renewal_date;
            },
            error: (response) => {
                display_errors(document.getElementById('SubscriptionLoadErrors'), response);
            }
        });
    }
};
